module.exports = __webpack_public_path__ + "static/img/beb2cee2-1a51-44ca-848f-4f795394ee5a.b8d79de.svg";